// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"0cba98ba","453":"c7a2a934","906":"fc7bc52c"}[chunkId] + ".chunk.js";
};